<template>
  <div>
    <Header v-if="isAuthenticated" />

    <router-view />

    <Footer v-if="isAuthenticated" />
  </div>
</template>

<script>
import Header from './Header/Header.vue'
import Footer from './Footer/Footer.vue'

export default {
  name: 'Main',

  components: {
    Header,
    Footer
  },

  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },

    darkMode() {
      return this.$store.state.darkMode
    }
  },

  watch: {
    darkMode: {
      immediate: true,

      handler(value) {
        document.body.classList.toggle(
          'dark-theme',
          value
        )
      }
    }
  },

  async mounted() {
    this.$store.dispatch('initAuth')
    this.$store.dispatch('loadWishlist')
    this.$store.dispatch('loadCart')
    this.$store.dispatch('loadDarkMode')

    await this.$store.dispatch('fetchBooks')
  },

  beforeDestroy() {
    document.body.classList.remove(
      'dark-theme'
    )
  }
}
</script>